export function mapStatus(
  status:
    | 'running'
    | 'queued'
    | 'completed'
    | 'failed'
    | 'success'
    | 'error'
    | 'pending'
): 'pending' | 'success' | 'error' | null {
  if (status === 'running' || status === 'queued' || status === 'pending') {
    return 'pending';
  } else if (status === 'completed' || status === 'success') {
    return 'success';
  } else if (status === 'failed' || status === 'error') {
    return 'error';
  } else {
    return null;
  }
}
